import { memo } from 'react'

import FilterRow, { TEST_ID } from './FilterRow'
import type { Props as FilterRowProps } from './FilterRow'

const FilterRowComponent = memo(FilterRow)

export { TEST_ID, FilterRowProps }

export default FilterRowComponent
